import { api } from '../lib/api';
import type { NotificationEvent } from './notifications';

/**
 * The inbox: what happened to your recordings, newest first. Every event
 * lands here whatever the email and push switches say.
 */

export interface InboxItem {
  id: string;
  event: NotificationEvent;
  /** The recording's title. */
  title: string;
  /** One line on what happened. */
  body: string;
  /** The page a click opens, as a path on this app. */
  url: string;
  readAt: string | null;
  createdAt: string;
  /** The recording is gone; the page behind the item will not open. */
  videoGone: boolean;
}

export interface InboxPage {
  items: InboxItem[];
  unread: number;
  nextCursor: string | null;
}

export function fetchInbox(options: { cursor?: string | null; limit?: number; unreadOnly?: boolean } = {}): Promise<InboxPage> {
  const params = new URLSearchParams();
  if (options.cursor) params.set('cursor', options.cursor);
  if (options.limit) params.set('limit', String(options.limit));
  if (options.unreadOnly) params.set('unread', '1');
  const search = params.toString();
  return api<InboxPage>(`/v1/me/inbox${search ? `?${search}` : ''}`);
}

export function fetchUnread(): Promise<{ unread: number }> {
  return api<{ unread: number }>('/v1/me/inbox/unread');
}

/** Some by id, or everything with no ids. */
export function markRead(ids?: string[]): Promise<{ unread: number }> {
  return api<{ unread: number }>('/v1/me/inbox/read', { method: 'PUT', body: ids ? { ids } : {} });
}
